export default [
  "de",
  "es",
  "fi",
  "fr",
  "hr",
  "hu",
  "it",
  "ja",
  "nl",
  "no",
  "pt",
  "ru",
  "sv",
  "zh-Hans",
];
